import * as React from 'react';
import { observer } from "@legendapp/state/react";
import { observable } from '@legendapp/state';
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { FormInput } from "_components/form";
import { AttendanceSituation, AttendanceSituationOptions } from "_enums/AttendanceSituation";
import { useConferenceEnd } from "_api/hooks/Client/conferences";
import { Button } from '_ui/Button';
import { toastRun } from "_utils/misc";
import { useGoBack } from '_utils/url';
import { $currentConferenceId, $selectedSituation } from '../state';
import { $npsOpen } from './Nps';


const $openAskConferenceSituation = observable(false);
export const openAskConferenceSituation = () => {
    $openAskConferenceSituation.set(true);
}

const hideAskConferenceSituation = () => {
    $openAskConferenceSituation.set(false);
}

export const AskConferenceSituation = observer(() => {
    const conferenceId = $currentConferenceId.$!;

    const { mutateAsync: end, isPending: loading } = useConferenceEnd(conferenceId);
    const back = useGoBack();

    const options = AttendanceSituationOptions;

    const form = useForm({
        defaultValues: {
            situation: AttendanceSituation.Resolved,
        },
    });
    const {
        register,
        control,
        formState: { errors },
    } = form;

    const onSubmit = async () => {
        hideAskConferenceSituation();
        $selectedSituation.set(form.getValues().situation);
        $npsOpen.set(true);
    }

    return (
        <Modal show={$openAskConferenceSituation.get()} onHide={hideAskConferenceSituation} backdrop="static">
            <Modal.Header>
                <Modal.Title>
                    Atendimento finalizado
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <FormInput
                    label='Situação da sua solicitação'
                    name='situation'
                    type='select'
                    placeholder='Cívil'
                    containerClass='w-100'
                    {...{ register, errors, control, options }}
                />
            </Modal.Body>

            <Modal.Footer>
                <Button onClick={onSubmit} {...{ loading }} text='Encerrar' />
            </Modal.Footer>
        </Modal>
    );
});
